export const TransactionFileHelper = {
    normalizeData(newData, files) {
        if (files) {
            files.forEach(item => {
                newData.files.push({
                    file_id: item.file_id,
                    is_shared: item.is_shared,
                });
            });
        }
    },
};
